import { RouteComponentProps } from "@reach/router";
import { FunctionComponent } from "react";
import NotFound from "../../pages/not-found";
import { User, UserType } from "./types";

interface RouteGuardProps {
  currentUser: User | null;
  component: FunctionComponent<RouteComponentProps>;
  allowedUserTypes: UserType[];
  path: string;
}

export const RouteGuard: FunctionComponent<RouteGuardProps> = ({
  currentUser,
  component: RouteComponent,
  allowedUserTypes,
  path
}) => {
  return allowedUserTypes.includes(currentUser?.userType as UserType) ? (
    <RouteComponent path={path} />
  ) : (
    <NotFound />
  );
};

// const permissions = [
//   {
//     "authority": "ROLE_CAN_SEE_ISW_LINKS"
//   },

//   {
//     "authority": "ROLE_CAN_SEE_FINTECH_LINKS"
//   }
// ]
